// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1-viM","ranges":"BmiRanges_ranges__2hCKI"};